import React from "react";
import { useNavigate } from "react-router-dom";

export default function AdmissionTestPage() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  };

  return (
    <div className="container mx-auto px-4 py-6 md:py-4">
      <button
        onClick={goBack}
        className="mb-4 flex items-center gap-3 text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg py-3 px-6 shadow-md hover:shadow-lg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6"
        >
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
        <span className="font-medium text-lg">Go Back</span>
      </button>

      <div className="border-0 shadow-lg overflow-hidden rounded-lg">
        <div className="bg-[#1e3a8a] text-white p-4 md:p-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center md:space-x-4 text-center md:text-left">
              <img
                src="/logo.png"
                alt="NASTP Logo"
                width={80}
                height={80}
                className="rounded-full mb-2 md:mb-0"
              />
              <div>
                <h1 className="text-xl md:text-2xl lg:text-3xl font-bold tracking-tight">
                  NASTP INSTITUTE OF INFORMATION
                </h1>
                <h2 className="text-lg md:text-xl lg:text-2xl font-bold tracking-tight">
                  TECHNOLOGY (NIIT), LAHORE
                </h2>
              </div>
            </div>
            <img
              src="/air-logo-transpatrent.png"
              alt="Air University Logo"
              width={100}
              height={100}
              className="mt-2 md:mt-0"
            />
          </div>
        </div>

        <div className="p-0">
          <div className="bg-gray-100 py-6 px-4 md:py-8 md:px-6">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-gray-800">
              NIIT Admission Test
            </h2>
          </div>

          {/* Test Pattern Section */}
          <div className="bg-blue-50 p-4 md:p-6 mt-6 md:mt-8">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-center text-blue-700">
              TEST PATTERN
            </h3>
            <p className="text-base md:text-lg text-gray-700 mt-3 md:mt-4">
              The admission test will comprise three sections: Verbal,
              Quantitative, and Analytical Reasoning. It will be conducted in a
              multiple-choice question (MCQ) format with no negative marking.
              The test will be computer-based and administered at the NIIT
              Campus, located at 69-Abid Majeed Road, Lahore Cantt.
            </p>
            <ul className="list-disc pl-4 md:pl-6 mt-3 md:mt-4 text-sm md:text-base ">
              <li>Test Duration: 90 minutes</li>
              <li>
                Questions Distribution:
                <ul className="list-inside list-disc  pl-2">
                  <li>Verbal Section: 40 questions</li>
                  <li>Quantitative Section: 40 questions</li>
                  <li>Analytical Reasoning: 20 questions</li>
                </ul>
              </li>
            </ul>
          </div>

          {/* Test Curriculum Section */}
          <div className="bg-blue-50 p-4 md:p-6 mt-6 md:mt-8">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-center text-blue-700">
              TEST CURRICULUM
            </h3>

            <h4 className="text-lg md:text-xl lg:text-2xl font-bold text-blue-700 mt-4 md:mt-6">
              QUANTITATIVE SECTION
            </h4>
            <p className="text-sm md:text-base lg:text-lg text-gray-700 mt-2 md:mt-4">
              This section assesses the candidate's ability to apply
              mathematical concepts and numerical reasoning to solve real-world
              and theoretical problems. It measures fluency in arithmetic,
              algebra, geometry, and applied physics through logical
              problem-solving and formula-based calculations.
            </p>
            <ul className="list-disc pl-4 md:pl-6 mt-2 md:mt-4 text-sm md:text-base">
              <li>
                <strong>Algebra:</strong> Linear equations in one and two
                variables, Quadratic equations and their roots, Inequalities and
                absolute values, Algebraic expressions and factorization
              </li>
              <li>
                <strong>Arithmetic:</strong> Percentages, ratios, and
                proportions, Averages and weighted averages, Profit, loss, and
                discount, Simple and compound interest, Time, work, and wages
              </li>
              <li>
                <strong>Speed, Distance & Time:</strong> Uniform and relative
                motion, Train, boat, and round-trip problems, Average speed and
                conversion (km/hr to m/s)
              </li>
              <li>
                <strong>Data Interpretation:</strong> Tables, bar graphs, pie
                charts, and line charts, Calculations involving percentages,
                ratios, comparisons, Interpreting trends and totals from data
                sets
              </li>
              <li>
                <strong>Geometry & Mensuration:</strong> Properties of
                triangles, circles, and polygons, Angles, parallel lines, and
                transversal rules, Perimeter, area, and volume of 2D/3D shapes
              </li>
              <li>
                <strong>Applied Physics (Quantitative Concepts):</strong>{" "}
                Newton's laws of motion, Speed, velocity, and acceleration,
                Power, work, energy, Current, voltage, resistance, Series /
                Parallel circuits
              </li>
              <li>
                <strong>Number Systems & Basic Operations:</strong> Factors,
                multiples, LCM & HCF, Prime numbers and divisibility rules,
                Operations with integers, fractions, and decimals
              </li>
              <li>
                <strong>Sets and Venn Diagrams:</strong> Union, intersection,
                and complement of sets, Word problems involving three-set Venn
                diagrams
              </li>
            </ul>

            <h4 className="text-lg md:text-xl lg:text-2xl font-bold text-blue-700 mt-4 md:mt-6">
              ANALYTICAL SECTION
            </h4>
            <p className="text-sm md:text-base lg:text-lg text-gray-700 mt-2 md:mt-4">
              This section evaluates a candidate's logical thinking, pattern
              recognition, and structured problem-solving ability — essential
              skills for reasoning through complex scenarios, identifying
              relationships, and making valid deductions.
            </p>
            <ul className="list-disc pl-4 md:pl-6 mt-2 md:mt-4 text-sm md:text-base">
              <li>
                <strong>Pattern and Series Recognition:</strong> Number and
                Letter Patterns, Identifying logic in sequences using alternate
                patterns or embedded rules, Mixed sequences involving numbers,
                letters, and symbols (non-math focused)
              </li>
              <li>
                <strong>Analogical Reasoning:</strong> Shape/Pattern analogies,
                Abstract relationships between figures, symbols, or logical
                structures
              </li>
              <li>
                <strong>Logical Puzzles:</strong> Seating Arrangements, Linear
                and circular arrangements, With or without directional
                constraints
              </li>
              <li>
                <strong>Direction and Orientation Problems:</strong> Determining
                final direction after a series of turns, Computing distance
                between start and endpoint
              </li>
              <li>
                <strong>Blood Relations:</strong> Direct and Coded
                Relationships, Puzzle-based family trees
              </li>
              <li>
                <strong>Coding-Decoding:</strong> Symbolic or rule-based
                encoding, Questions involving assigning codes to letters/words
              </li>
              <li>
                <strong>Logical Deductions:</strong> Statement and Conclusion
                (logical), Evaluating logically valid inferences from conditions
              </li>
              <li>
                <strong>Ranking and Order Puzzles:</strong> Determining
                position/rank based on height, score, or sequence rules
              </li>
              <li>
                <strong>Matrix and Grid-Based Reasoning:</strong> Solving
                conditions-based problems in a table/grid format
              </li>
              <li>
                <strong>Venn Diagram-Based Logical Sets:</strong> Deductive
                analysis using set overlaps
              </li>
            </ul>

            <h4 className="text-lg md:text-xl lg:text-2xl font-bold text-blue-700 mt-4 md:mt-6">
              VERBAL SECTION
            </h4>
            <p className="text-sm md:text-base lg:text-lg text-gray-700 mt-2 md:mt-4">
              This section measures a candidate's proficiency in English
              language comprehension, grammar, and vocabulary. It assesses the
              ability to understand written passages, correct sentence
              structure, and interpret word meanings in context.
            </p>
            <ul className="list-disc pl-4 md:pl-6 mt-2 md:mt-4 text-sm md:text-base">
              <li>
                <strong>Reading Comprehension:</strong> Understanding the main
                idea, tone, and purpose of a passage, Identifying facts vs.
                opinions, Drawing inferences and conclusions,
                Vocabulary-in-context questions, Literal and interpretative
                comprehension
              </li>
              <li>
                <strong>Vocabulary:</strong> Synonyms and Antonyms, Word
                meanings and usage in sentences, Context-based vocabulary,
                One-word substitutions, Commonly confused words
              </li>
              <li>
                <strong>Sentence Completion:</strong> Choosing the most
                appropriate word or phrase to complete a sentence, Contextual
                understanding of grammar and vocabulary, Logical flow and
                coherence
              </li>
              <li>
                <strong>Sentence Correction / Spotting Errors:</strong>{" "}
                Identifying grammatical errors in sentence structure,
                Subject–verb agreement, Tense consistency, Prepositions,
                conjunctions, and article usage, Redundancy and parallel
                structure errors
              </li>
              <li>
                <strong>Idioms and Phrases:</strong> Common idiomatic
                expressions in English, Meaning and contextual usage, Selecting
                equivalent or appropriate phrases
              </li>
              <li>
                <strong>Analogies:</strong> Word-pair relationships (e.g.,
                cause-effect, part-whole, synonym-antonym), Identifying logical
                and semantic relationships
              </li>
              <li>
                <strong>
                  Active and Passive Voice / Direct and Indirect Speech:
                </strong>{" "}
                Basic transformation of sentences, Recognizing correct verb
                forms in speech conversion
              </li>
              <li>
                <strong>Para Jumbles / Sentence Arrangement:</strong> Reordering
                sentences to form a logical paragraph, Identifying the correct
                sequence of ideas or events
              </li>
            </ul>
          </div>

          {/* Sample Test Links Section */}
          <div className="bg-blue-50 p-4 md:p-6 mt-6 md:mt-8">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-center text-blue-700">
              Sample Tests
            </h3>
            <div className="space-y-3 md:space-y-4 mt-3 md:mt-4">
              <p className="text-base md:text-lg text-gray-700">
                You can practice with the following sample tests:
              </p>
              <ul className="list-none space-y-1 md:space-y-2">
                <li>
                  <a
                    href="https://forms.gle/CuFb2T3yn12M8sxr6"
                    className="text-blue-600 hover:underline text-sm md:text-base"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sample Test #1
                  </a>
                </li>
                <li>
                  <a
                    href="https://forms.gle/aJodiaaPyx5Tgrdy8"
                    className="text-blue-600 hover:underline text-sm md:text-base"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sample Test #2
                  </a>
                </li>
                <li>
                  <a
                    href="https://forms.gle/QB7nbBFLDwh1M3gv6"
                    className="text-blue-600 hover:underline text-sm md:text-base"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sample Test #3
                  </a>
                </li>
                <li>
                  <a
                    href="https://forms.gle/48FV89959cWQX5wz7"
                    className="text-blue-600 hover:underline text-sm md:text-base"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sample Test #4
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-6 md:mt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-gray-700 p-4 md:p-6">
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="text-base md:text-lg">
                69-Abid Majeed Road, Lahore Cantt
              </span>
            </div>
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span className="text-base md:text-lg">0320-9420163</span>
            </div>
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 md:h-6 md:w-6 text-blue-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span className="text-base md:text-lg">042-36666033</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
